/**
 * Rutas internas del panel que **viajan por la API**.
 *
 * `Alert.href` es parte del contrato: el servidor arma la dirección y el front
 * la usa. Con el constructor de un lado y el router del otro, las dos se
 * desincronizaron: `/entrevistas` linkeaba a 57 fichas de cliente que el router
 * no declaraba y caían en "Esa pantalla no existe". El front ya centralizó su
 * constructor en `apps/web/src/lib/rutas.ts`; el servidor seguía armando la
 * misma ruta con un template literal a mano.
 *
 * Por eso el constructor vive acá, en el paquete que los dos importan: es el
 * mismo lugar donde está declarado el campo que lo transporta.
 *
 * El patrón del router (`/clientes/:clientId`) **no** vive acá: la sintaxis del
 * `:param` es de React Router y el servidor no la conoce. Vive en el front,
 * armado sobre `RUTA_CLIENTES`.
 */

/** Listado de clientes. Cerrar la ficha vuelve acá. */
export const RUTA_CLIENTES = '/clientes'

/**
 * Admin. Es la pantalla donde se cargan los ids externos y se ve qué variable
 * de deep link quedó vacía, así que es el destino de toda acción de "esto no
 * está configurado".
 */
export const RUTA_ADMIN = '/admin'

/**
 * Ficha de una cuenta. Es una dirección de verdad: se puede refrescar,
 * compartir y abrir en otra pestaña, igual que los registros de los sistemas de
 * origen.
 */
export function rutaCliente(clientId: string): string {
  return `${RUTA_CLIENTES}/${encodeURIComponent(clientId)}`
}
